import React from 'react';
import { GenericFilterProps, RangeTuple } from '../types';
import { Section, SectionBody, SectionTitle } from '../styled/common';
import Range from 'ds/components/input/RangeField/RangeField';
import { useLocale } from 'locale';
import { parseRangeValues, prepareRangeValues } from '../utils';
import { useScreenBreakpoint } from 'consts/breakpoints';

const VISIBLE_ITEMS_COUNT = 5;

const Area: React.FC<GenericFilterProps <'areaRange'>> = ({
  type,
  intermediateValue,
  setIntermediateValue,
  config,
}) => {
  const { t } = useLocale();
  const onChange = ([ from, to ]: RangeTuple<number>) => {
    setIntermediateValue([ parseRangeValues(from), parseRangeValues(to) ]);
  };
  const { areaOptions } = config;
  const options = areaOptions.map((v) => ({
    value: v,
    label: t('filters.areaLabels', { area: v }) || `${v}`,
  }));

  const isCombinedFiltersSearchView = useScreenBreakpoint() < 3;

  return (
    <Section
      combinedFiltersSearchMode={isCombinedFiltersSearchView}
      data-section-filter-name={type}
      data-auto-filter-name={type}
      data-auto={`filter-${type}`}
    >
      <SectionTitle isBold combinedFiltersSearchMode={isCombinedFiltersSearchView}>{t('filters.area')}</SectionTitle>
      <SectionBody combinedFiltersSearchMode={isCombinedFiltersSearchView}>
        <Range
          expandOptionsPosition="bottom"
          onChange={onChange}
          values={prepareRangeValues(intermediateValue)}
          options={options}
          readOnly
          fullWidth
          visibleItemsCount={VISIBLE_ITEMS_COUNT}
          mode={isCombinedFiltersSearchView ? 'black' : 'default'}
          labelFrom={isCombinedFiltersSearchView ? t('filters.area.from') : undefined}
          labelTo={isCombinedFiltersSearchView ? t('filters.area.to') : undefined}
        />
      </SectionBody>
    </Section>
  );
};

export default React.memo(Area);
